import { render, staticRenderFns } from "./ChoiceRes.vue?vue&type=template&id=0dc071a4"
import script from "./ChoiceRes.vue?vue&type=script&lang=js"
export * from "./ChoiceRes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports